import api from "../axiosInstance";

const homeService = {
  getSummary: () => api.get(`/vehicle/summary`),
  updateVariant: (leadId, data) => api.put(`/vehicle/${leadId}/variant`, data),
  getDataTable: (body) => api.post("/vehicle/search", body),
  getDataTableV2: (body) => api.post("/vehicle/search/v2", body),
  saveFilterView: (payload) => api.post("/user/views", payload),
  getSaveFilterView: () => api.get("/user/views")
};

export default homeService;
